import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DisplayService } from 'src/app/services/display.service';


@Component({
  selector: 'app-status-message',
  templateUrl: './status-message.component.html',
  styleUrls: ['./status-message.component.css'],
  animations: [
    // animation triggers go here
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusMessageComponent {

  @Input() statusMessageType: string = "";
  @Input() editMoreAvailable: boolean = false;
  @Input() layerToDelete: string = "";
  @Output() openLayerEditEE = new EventEmitter();
  @Output() sendDeleteOptionsEE = new EventEmitter();

  file: boolean = false;
  layer: boolean = false;
  style: boolean = false;

  constructor(private displayService: DisplayService) { }

  closeAddLayer(): void {
    this.displayService.toggleAddLayerActive()
  }

  openAddLayerMenu(reFetchData: boolean): void {
    //console.log("Refetch data?: " + reFetchData)
    //console.log(typeof(reFetchData))
    this.openLayerEditEE.emit(reFetchData)
  }


  sendDeleteOptions(): void {
    //console.log("File: " + this.file)
    //console.log("Layer: " + this.layer)
    //console.log("Style: " + this.style)

    const deleteOptions = {
      file: this.file,
      layer: this.layer,
      style: this.style
    }

    this.sendDeleteOptionsEE.emit(deleteOptions)
  }
}
